export default __webpack_public_path__ + "static/lab-cf136601816fcc95f7054865018d689b.webp";